// -- little wrapper for the URL object to minimize repition tasks
function UrlHelper(href) {

    const url = new URL(href || window.location.href);

    // -- get query parameter by key
    this.get = function (key) {
        const value = url.searchParams.get(key);

        if (value) {
            return value.toString().trim();
        }

        return null;
    }

    // -- set query parameter by key
    this.set = function (key, value) {

        if (!value) {
            return;
        }

        url.searchParams.set(key.toString(), value.toString().trim());
        window.history.replaceState(null, null, '?' + url.searchParams.toString());
    }

    this.append = function (key, value) {
        url.searchParams.append(key, value);
    }

    // -- remove query parameter by key
    this.delete = function(key) {
        url.searchParams.delete(key);
    }

    this.getTrackId = function () {

        const trackId = this.get('track_id');

        if(!trackId || trackId.length !== 64) {
            return null;
        }

        return trackId;
    }

    // -- forward property and method calls to this class or underlying url object
    return new Proxy(this, {

        get(target, prop) {

            // -- call toString() on the url object
            if(prop === 'toString') {
                target = url;
            }

            // -- if method/property is undefined, try to call it on the url object
            if(typeof target[prop] === 'undefined') {
                target = url;

                // -- still undefined? return undefined
                if(typeof target[prop] === 'undefined') {
                   return;
                }
            }

            let method = target[prop];

            if (typeof method === 'function') {
                return function (...args) {
                    return method.apply(target, args)
                }
            }

            // -- return object property
            return method;
        },

        set(target, prop, value) {

            if(typeof url[prop] !== 'undefined') {
                url[prop] = value;
                return true;
            }
        }
    })

}